/**
 * Connector
 *
 * @module connector
 */
 const component = {

    /**
     * Init component
     *
     * @returns {undefined}
     */
    init: () => {

        /**
         * Connector module api
         *
         * @global
         */
        window.theme.connector = component;
    },

    /**
     * Make a request to get product data.
     *
     * @public
     * @method
     * @name request
     * @todo Implement a test for this function.
     * @param {string} identifier Product identifier.
     * @returns {Promise} Promise object represents a product.
     */
    getProduct: (identifier) => {

        return new Promise((resolve, reject) => {

            let url = '/products/' + identifier + '?view=json';

            fetch(url).then(resp => {

                return resp.json();

            }).then(productData => {

                if (productData) {

                    resolve(productData);

                } else {

                    reject(productData);
                }
            });
        });
    },

    /**
     * Make a request to get cart data.
     *
     * @public
     * @method
     * @name request
     * @todo Implement a test for this function.
     * @returns {Promise} Promise object represents a cart.
     */
    getCart: () => {

        return new Promise((resolve, reject) => {

			fetch('/cart.js', { credentials: 'same-origin' }).then(function(response) {

				return response.json();

			}).then(function(cart) {

				resolve(cart);

			}).catch(function(error) {

				reject(error);
			});
		});
    },

    addToCart: (id, qty, properties, formData) => {
        return new Promise((resolve, reject) => {

            // let bodyObj = {
            //     id: id,
            //     quantity: qty,
            // }

            // if(properties){
            //     bodyObj.properties = properties;
            // }

            // put the first id, qty and properties under the first item
            const items = [{ id, quantity: qty, properties }];

            // if there are properties with 'Label Config ID' it means that there was a label created
            // add another item to the cart with the label config id
						if (properties && properties['Label Config ID']) {
							let object = {};
							formData.forEach((value, key) => object[key] = value);

							const label = {
								id: formData.get('label-type'),
								quantity: formData.get('label-type-qty'),
								properties: {
									'Label Config ID': properties['Label Config ID']
								}
							};

							console.log('label:', label);

							items.push(label);
						}

            // if the customer requested to apply labels add that one as well
            if (formData.get('apply-labels') === 'Yes') {
                const applyLabel = { id: formData.get('label-application-id'), quantity: formData.get('label-type-qty'), properties: { 'Apply Labels': 'Yes', 'Label Config ID': properties['Label Config ID'] }};
                items.push(applyLabel);
            }

			let request = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json;'
				},
				body: JSON.stringify({items})
			};

			fetch('/cart/add.js', request).then(function(response) {
				return response.json();
			}).then(function(json) {
				if (json.status && json.status !== 200) {
					var error = new Error(json.description);
					error.isFromServer = true;
					throw error;
				}
                console.log('IF');

				resolve(true);

			}).catch(function(error) {

                console.log('CATCH');
				reject(error);
			});
		});
    },

    updateItemFromCart: (id, qty, properties) => {

        return new Promise((resolve, reject) => {

			// Create the request
			let request = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json;'
				},
				body: JSON.stringify({
					id: id,
					quantity: qty
				})
			};

			// Make a request
			fetch('/cart/change.js', request).then(function(response) {
				return response.json();
			}).then(function(json) {

				if (json.status && json.status !== 200) {
					var error = new Error(json.description);
					error.isFromServer = true;
					throw error;
				}

				resolve(json);

			}).catch(function(error) {
				reject(error);
			});
		});
    }
};

export default component;
